import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, Coins, CreditCard, Gift, Ticket } from "lucide-react";

import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { TIPOS_CLIENTE } from "./tipos";

// Para onde cada oferta leva (a tela abre já com o tipo marcado: ?para=<tipo>)
const OFERTAS = [
  { rota: "/admin/impulsione/promocoes", nome: "Promoção", detalhe: "preço especial em produtos", Icone: Gift },
  { rota: "/admin/impulsione/cupons", nome: "Cupom de desconto", detalhe: "desconto com código", Icone: Ticket },
  { rota: "/admin/impulsione/fidelize/cartao-fidelidade", nome: "Cartão fidelidade", detalhe: "carimbo a cada compra", Icone: CreditCard },
  { rota: "/admin/impulsione/fidelize/cashback", nome: "Cashback", detalhe: "crédito de volta", Icone: Coins },
];

/**
 * "Criar oferta" nos cards de tipo da tela de Clientes (pedido do dono,
 * 27/10/2026): escolhe Promoção, Cupom, Cartão fidelidade ou Cashback e abre a
 * tela com aquele tipo de cliente já marcado em "para quem vale".
 */
export default function BotaoOfertas({ tipo }) {
  const navigate = useNavigate();
  const t = TIPOS_CLIENTE[tipo];
  if (!t) return null;
  const parar = (e) => e.stopPropagation(); // o card filtra a lista ao clicar
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" onClick={parar} data-e2e={`ofertas-${tipo}`}
          className="w-full h-7 rounded-md border border-dashed border-primary/40 text-[11px] font-semibold text-primary hover:bg-primary/10 inline-flex items-center justify-center gap-1">
          <Gift className="w-3.5 h-3.5" /> Criar oferta <ChevronDown className="w-3 h-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" onClick={parar} className="w-64">
        <DropdownMenuLabel className="text-xs">Oferta só para clientes {t.curto}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {OFERTAS.map((o) => (
          <DropdownMenuItem key={o.rota} onClick={() => navigate(`${o.rota}?para=${tipo}`)} data-e2e={`ofertas-${tipo}-${o.rota.split("/").pop()}`}
            className="flex items-start gap-2.5 py-2 cursor-pointer">
            <o.Icone className="w-4 h-4 mt-0.5 text-primary shrink-0" />
            <span>
              <span className="block text-sm font-medium">{o.nome}</span>
              <span className="block text-[11px] text-muted-foreground">{o.detalhe}</span>
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
